import type { SxProps, Theme } from '@mui/material/styles';

export const getPanelStyles = (isMenuOpen: boolean): SxProps<Theme> => ({
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  width: 480,
  backgroundColor: 'background.paper',
  boxShadow: isMenuOpen ? '4px 0 16px rgba(0, 0, 0, 0.12)' : 'none',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.3s ease-in-out, visibility 0.3s',
  zIndex: 2,
  transform: isMenuOpen ? 'translateX(0)' : 'translateX(-100%)',
  visibility: isMenuOpen ? 'visible' : 'hidden',
  // visibility only flips to hidden once the 0.3s transition ends, so block clicks on a closing menu right away
  pointerEvents: isMenuOpen ? 'auto' : 'none',
});

export const getHeaderStyles = (isDragging: boolean): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  px: 2,
  py: 1.5,
  borderBottom: '1px solid',
  borderColor: 'divider',
  flexShrink: 0,
  userSelect: 'none',
  cursor: isDragging ? 'grabbing' : 'grab',
});

export const FOOTER_STYLES: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  gap: 1.5,
  px: 2,
  py: 1.5,
  borderTop: '1px solid',
  borderColor: 'divider',
  flexShrink: 0,
};
